import React, { useEffect, useState } from 'react';
import { LabShell } from './lab/LabShell.js';
import { seedCommunityData } from './lab/bench.js';
import { MissionControl } from './missionControl/MissionControl.js';
import { ArenaView } from './views/ArenaView.js';
import { MemoryView } from './views/MemoryView.js';
import { RunsView } from './views/RunsView.js';
import { TrustView } from './views/TrustView.js';

type Pillar = 'mission' | 'runs' | 'trust' | 'arena' | 'memory' | 'lab';

const PILLARS: { id: Pillar; label: string; kicker: string }[] = [
  { id: 'mission', label: 'Mission', kicker: 'Agent lanes' },
  { id: 'runs', label: 'Runs', kicker: 'Timeline & replay' },
  { id: 'trust', label: 'Trust', kicker: 'Safety & compliance' },
  { id: 'arena', label: 'Arena', kicker: 'Race · bench · speed' },
  { id: 'memory', label: 'Memory', kicker: 'Knowledge & napkin' },
  { id: 'lab', label: 'Lab', kicker: 'Local model routing' },
];

export default function App() {
  const [mode, setMode] = useState<'beginner' | 'pro'>('beginner');
  const [pillar, setPillar] = useState<Pillar>('mission');

  useEffect(() => {
    seedCommunityData();
  }, []);

  return (
    <div className="app-shell">
      <div className="background-orbit background-orbit-a" />
      <div className="background-orbit background-orbit-b" />

      <header className="topbar panel">
        <div className="brand-block">
          <div className="brand-mark">VT</div>
          <div>
            <div className="eyebrow">Vibetime Mission Control</div>
            <h1>Live multi-agent command center with signed receipts and voice-to-coordinator.</h1>
          </div>
        </div>

        <div className="topbar-actions">
          <div className="pillar-switch" role="tablist" aria-label="Dashboard pillar">
            {PILLARS.map((p) => (
              <button
                key={p.id}
                type="button"
                role="tab"
                aria-selected={pillar === p.id}
                className={pillar === p.id ? 'pillar-active' : ''}
                onClick={() => setPillar(p.id)}
                title={p.kicker}
              >
                {p.label}
              </button>
            ))}
          </div>

          <button
            className={`mode-toggle ${mode === 'beginner' ? 'mode-active' : ''}`}
            onClick={() => setMode('beginner')}
            type="button"
          >
            Beginner
          </button>
          <button
            className={`mode-toggle ${mode === 'pro' ? 'mode-active' : ''}`}
            onClick={() => setMode('pro')}
            type="button"
          >
            Pro
          </button>
        </div>
      </header>

      {pillar === 'mission' && <MissionControl mode={mode} onOpenLab={() => setPillar('lab')} />}
      {pillar === 'runs' && <RunsView mode={mode} />}
      {pillar === 'trust' && <TrustView mode={mode} />}
      {pillar === 'arena' && <ArenaView mode={mode} />}
      {pillar === 'memory' && <MemoryView mode={mode} />}
      {pillar === 'lab' && <LabShell mode={mode} />}
    </div>
  );
}
